var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.799 17.066a1 1 0 0 1 .2.6v1.26a.5.5 0 0 0 .602.49l1.304-.271a1 1 0 0 1 .604.063l.292.127A7.967 7.967 0 0 0 12 20a8 8 0 1 0-8-8c0 1.803.594 3.462 1.598 4.799l.2.267ZM8 21.168A9.966 9.966 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 2.251.744 4.329 2 6v2.77a1 1 0 0 0 1.203.98L8 21.168Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.456 9.778-2.751 3.93a.426.426 0 0 0 .586.598l2.172-1.448a1 1 0 0 1 1.084-.016l2.648 1.655a1 1 0 0 0 1.35-.274l2.75-3.93a.426.426 0 0 0-.586-.6l-2.172 1.449a1 1 0 0 1-1.085.016l-2.647-1.655a1 1 0 0 0-1.35.275Z",
    fill: "#777E91"
  })));
};
export default SvgLine;